var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 27,
    viewBox: "0 0 47 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 26.1111,
    rx: 4.7,
    fill: "#F8F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4244 18.0838H18.6885L20.3997 7.50293H23.1354L21.4244 18.0838Z",
    fill: "#2B2B71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3417 7.76199C30.802 7.5479 29.9461 7.31152 28.8878 7.31152C26.186 7.31152 24.2835 8.75225 24.2718 10.8121C24.2493 12.3318 25.634 13.1759 26.6696 13.6826C27.728 14.2004 28.0878 14.5383 28.0878 14.9999C28.0771 15.7087 27.2325 16.0355 26.4448 16.0355C25.3526 16.0355 24.7673 15.867 23.8779 15.4726L23.5176 15.3036L23.1348 17.6788C23.7764 17.9711 24.9586 18.2305 26.186 18.2419C29.0567 18.2419 30.9256 16.8234 30.9477 14.6284C30.9587 13.4239 30.2275 12.501 28.6513 11.7468C27.6944 11.2627 27.1084 10.9362 27.1084 10.4409C27.1196 9.99055 27.604 9.52931 28.6842 9.52931C29.5736 9.50672 30.2271 9.72051 30.7221 9.93445L30.9696 10.0468L31.3417 7.76199Z",
    fill: "#2B2B71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.978 14.3354C35.2033 13.7275 36.0703 11.3749 36.0703 11.3749C36.0589 11.3975 36.2951 10.7559 36.4302 10.3619L36.6214 11.2736C36.6214 11.2736 37.1395 13.8064 37.252 14.3354C36.8244 14.3354 35.5184 14.3354 34.978 14.3354ZM38.3551 7.50293H36.2389C35.5863 7.50293 35.0905 7.69413 34.8089 8.38083L30.7451 18.0837H33.6158C33.6158 18.0837 34.0884 16.7777 34.19 16.4965C34.5049 16.4965 37.2975 16.4965 37.7026 16.4965C37.7812 16.8679 38.0291 18.0837 38.0291 18.0837H40.5622L38.3551 7.50293Z",
    fill: "#2B2B71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4031 7.50293L13.7238 14.7181L13.431 13.2548C12.9356 11.5663 11.3821 9.73179 9.64844 8.81963L12.1026 18.0726H14.9957L19.2961 7.50293H16.4031Z",
    fill: "#2B2B71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2359 7.50391H6.83409L6.78906 7.7177C10.2227 8.59574 12.4968 10.7122 13.4311 13.2562L12.4742 8.39333C12.3166 7.71755 11.8325 7.5262 11.2359 7.50391Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.7734,
    height: 10.9304,
    fill: "white",
    transform: "translate(6.78906 7.31152)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.95d8f98f18324473009ce36915a0776f.svg";
export { ForwardRef as ReactComponent };